import { __awaiter } from "tslib";
import { composeWithDevTools } from 'redux-devtools-extension';
import { loadFromModuleCollectionImplementation } from '../rootModules';
import { configureDynamicStoreBase } from './storeConfigure.base';
export class StoreConfiguratorLocalDebug {
    constructor() {
        this.buildDynamic = (initialState, context, dynamicStore, componentReduxModules, history) => {
            const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 40 });
            return configureDynamicStoreBase(initialState, context, dynamicStore, componentReduxModules, history, composeEnhancers);
        };
    }
    loadFromModuleCollection(componentName, initialState) {
        return __awaiter(this, void 0, void 0, function* () {
            const moduleCollectionImplementation = yield loadFromModuleCollectionImplementation(componentName, initialState);
            return moduleCollectionImplementation;
        });
    }
}
